import { useLayoutEffect } from "react";

function useScrollAnchor() {
  useLayoutEffect(() => {
    const smoothScrollAnchor = document.querySelectorAll("a[href^='#']");

    for (let anchor = 0; anchor < smoothScrollAnchor.length; anchor++) {
      const element = smoothScrollAnchor[anchor];

      element.addEventListener("click", function (e) {
        e.preventDefault();

        const targetId = this.getAttribute("href").replace("#", "");
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // Fallback jika scrollIntoView tidak didukung
          const targetOffsetTop = targetElement.offsetTop;
          window.scrollTo({
            top: targetOffsetTop,
            behavior: "smooth"
          });
        }
      });
    }
    return () => {};
  }, []);
}

export default useScrollAnchor;
